import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSearchParams } from 'react-router-dom';

export default function Term() {
    const location = useLocation();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const lang = useSelector(state => state.langReducer.lang);
    const terms = useSelector(state => state.etcReducer?.terms);

    const [searchParams] = useSearchParams();
    const [content, setcontent] = useState('');

    useEffect(() => {
        console.log(terms);

        if(terms?.Terms){
            let termKey = searchParams.get('termKey');
            let currentLang = (lang === 0 ? 'ko' : 'en') || 'ko';
            let content = terms[termKey][currentLang]?.content || '';        
            setcontent(content);
            window.scrollTo(0, 0);
        }
    }, [terms, searchParams, lang]);

    useEffect(() => {

    }, []);

    useEffect(() => {
        const storedRegiSuc = localStorage.getItem('inqSuc');
        if (storedRegiSuc === '1') {
            const toastId = toast(lang === 0 ? '문의내용이 전송되었습니다' : 'Inquiries have been sent.');
            setTimeout(() => {
                toast.dismiss(toastId);
                localStorage.removeItem('inqSuc');
            }, 2000);
        }
    }, []);


    return (
        <>
            <div style={{ padding: "20px", textAlign: "left", width: "100%", marginTop: 80 }}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </>
    );
}
